import { render } from "./myImports.vue?vue&type=template&id=32d5415d&ts=true"
import script from "./myImports.vue?vue&type=script&lang=ts"
export * from "./myImports.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__